<!-- This file is auto-generated don't edit it!-->
<ui-menu-side-panel class="page-navigation">
    <ui-menu-group title="Buttons">
        <ui-menu-item
            title="ButtonGroup"
            path="/components/buttons/button-group"></ui-menu-item>
        <ui-menu-item
            title="Button"
            path="/components/buttons/button"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Collapse">
        <ui-menu-item
            title="Accordion"
            path="/components/collapse/accordion"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Dialogs">
        <ui-menu-item
            title="AlertDialog"
            path="/components/dialogs/alert-dialog"></ui-menu-item>
        <ui-menu-item
            title="ConfirmDialog"
            path="/components/dialogs/confirm-dialog"></ui-menu-item>
        <ui-menu-item
            title="Dialog"
            path="/components/dialogs/dialog"></ui-menu-item>
        <ui-menu-item
            title="ErrorDialog"
            path="/components/dialogs/error-dialog"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Icon">
        <ui-menu-item
            title="Flag"
            path="/components/icon/flag"></ui-menu-item>
        <ui-menu-item
            title="Icon"
            path="/components/icon/icon"></ui-menu-item>
        <ui-menu-item
            title="Image"
            path="/components/icon/image"></ui-menu-item>
        <ui-menu-item
            title="SvgIcon"
            path="/components/icon/svg-icon"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Inputs">
        <ui-menu-item
            title="Checkbox"
            path="/components/inputs/checkbox"></ui-menu-item>
        <ui-menu-item
            title="DatePicker"
            path="/components/inputs/date-picker"></ui-menu-item>
        <ui-menu-item
            title="Input"
            path="/components/inputs/input"></ui-menu-item>
        <ui-menu-item
            title="Number"
            path="/components/inputs/number"></ui-menu-item>
        <ui-menu-item
            title="Radio"
            path="/components/inputs/radio"></ui-menu-item>
        <ui-menu-item
            title="SelectableList"
            path="/components/inputs/selectable-list"></ui-menu-item>
        <ui-menu-item
            title="Textarea"
            path="/components/inputs/textarea"></ui-menu-item>
        <ui-menu-item
            title="ToggleSwitch"
            path="/components/inputs/toggle-switch"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Layout">
        <ui-menu-item
            title="List"
            path="/components/layout/list"></ui-menu-item>
        <ui-menu-item
            title="Panel"
            path="/components/layout/panel"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Loader">
        <ui-menu-item
            title="Loader"
            path="/components/loader/loader"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Navigation">
        <ui-menu-item
            title="Breadcrumbs"
            path="/components/navigation/breadcrumbs"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Notification">
        <ui-menu-item
            title="Notification"
            path="/components/notification/notification"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Popovers">
        <ui-menu-item
            title="Dropdown"
            path="/components/popovers/dropdown"></ui-menu-item>
        <ui-menu-item
            title="Popover"
            path="/components/popovers/popover"></ui-menu-item>
        <ui-menu-item
            title="Tooltip"
            path="/components/popovers/tooltip"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Select">
        <ui-menu-item
            title="Select"
            path="/components/select/select"></ui-menu-item>
    </ui-menu-group>
    <ui-menu-group title="Static">
        <ui-menu-item
            title="HelpMenu"
            path="/components/static/help-menu"></ui-menu-item>
    </ui-menu-group>
</ui-menu-side-panel>
